// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__dlvIN","headline":"style_headline__y2eVU","text":"style_text__tZ_xO"};